exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!./scroller.css"), "");

// module
exports.push([module.id, "\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fb7e968","scoped":false,"hasInlineConfig":false}!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vux/src/components/picker/index.vue
// module id = 256
// module chunks = 1